module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-buttom-item",
    class: {
      'mu-bottom-item-active': _vm.active
    },
    attrs: {
      "href": _vm.href,
      "disableTouchRipple": _vm.shift,
      "center-ripple": false,
      "wrapperClass": "mu-buttom-item-wrapper"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  }, [(_vm.icon) ? _c('icon', {
    staticClass: "mu-bottom-item-icon",
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.title) ? _c('span', {
    staticClass: "mu-bottom-item-text",
    class: _vm.titleClass
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ab68a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/bottomNav/bottomNavItem.vue
// module id = 499
// module chunks = 1